import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const MembersProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `GmailGroup/Member/${props.memberId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: `GmailGroup/${props.groupId}/Member`, method: 'POST', payload: props, secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `GmailGroup/Member`, method: 'PUT', payload: props, secure: true });
    }, [execute]);

    const listRecords = useCallback(async (props) => {
        await execute({ scope: 'list', url: `GmailGroup/Members/${props.groupId}`, method: 'GET', secure: true });
    }, [execute]);

    const userRoles = useCallback(async () => {
        await execute({ scope: 'listUserRoles', url: `GmailGroup/GroupEmailUserRoles`, method: 'GET', secure: true });

    }, [execute]);

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `GmailGroup/Member/${props.memberId}`, method: 'DELETE', secure: true });
    }, [execute]);

    const value = { selectRecord, listRecords, newRecord, userRoles, deleteRecord, updateRecord, createRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useMembersStore = () => React.useContext(Context);
